export default __webpack_public_path__ + "static/media/logo.665c7598.png";